export const mailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// export const nonstrongPwd =
//   /(?=.*[a-z])(?=.*)(?=.*[0-9])(?=.*[^a-z0-9])(?=.{8,})/;

export const nonstrongPwd =
  /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*]{8,}$/;

export const nNumber = 999999999999999;

export const gstinPattern =
  /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){1,15}$/;

export const razorpay_live_key = "rzp_live_LIlT9qwfh7UPfw";

export const BRANDING_OPTIONS = [
  "Lazer",
  "Screen Printing",
  "UV Printing",
  "Sublimination",
];

export const textfield_style = {
  "& .MuiInputLabel-root": {
    fontFamily: "Poppins",
  },
  "& .MuiOutlinedInput-root": {
    fontFamily: "Poppins",
    borderRadius: "12px",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#800000",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#800000",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #800000",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#800000",
  },
  backgroundColor: "white",
  marginTop: "15px",
};
